import { Region, ocr, faces, custom, rectangle } from "@cloudinary/transformation-builder-sdk/qualifiers/region";
export { Region, ocr, faces, custom, rectangle };
